
const planFeatures = {
    default: [
        "No daily limit",
        "Origin IP Geolocation",
        "Target IP Geolocation",
        "ASN organization",
        "Secure connection or SSL encryption",
        "Country information",
        "Country Timezone",
        "Country Currency",
        "Country Language",
        "Access Control Management",
        "Webhook",
        "Realtime Analytics",
        "API reports and history",
        "High Availability",
        "Low Latency"
    ],
    rplansFeatures: [
        "No daily limit",
        "Origin location",
        "Accurate locations",
        "Secure connection or SSL encryption",
        "Access Control Management",
        "Webhook",
        "Realtime Analytics",
        "API reports and history",
        "High Availability",
        "Low Latency"
    ]
}


export default planFeatures;